import { action, computed, makeObservable, observable } from 'mobx';
import { ApiErrorResponseFromJSON } from '@ibe/api';
import { removeTrailingSlashes } from '@ibe/services';
import CmsHotelData from '../Models/CMS/CmsHotelData';
import i18next from 'i18next';

class CmsHotelService {
  public _isBusy = false;

  private _apiUrl: string;

  public _hotel: CmsHotelData = new CmsHotelData();

  private readonly hotelUrl = '/cms/hotel';

  private readonly hotelsUrl = '/cms/hotels';

  constructor() {
    makeObservable(this, {
      _isBusy: observable,
      _hotel: observable,
      isBusy: computed,
      hotel: computed,
      fetchHotel: action
    });
  }

  get isBusy(): boolean {
    return this._isBusy;
  }

  get hotel(): CmsHotelData {
    return this._hotel ? this._hotel : new CmsHotelData();
  }

  set apiUrl(value: string) {
    this._apiUrl = removeTrailingSlashes(value);
  }

  async fetchHotel(code: string): Promise<CmsHotelData> {
    this._isBusy = true;
    try {
      const response = await fetch(this._apiUrl + this.hotelUrl + '/' + code, {
        headers: {
          'Accept-Language': i18next.language
        }
      });
      if (response && response.status !== 204) {
        const jsonResponse = await response.json();
        if (
          jsonResponse &&
          Object.entries(jsonResponse) &&
          Object.entries(jsonResponse).length > 0
        ) {
          this._hotel = jsonResponse;
        }
      }
      this._isBusy = false;
      return this._hotel;
    } catch (e) {
      this._hotel = new CmsHotelData();
      this._isBusy = false;
      throw ApiErrorResponseFromJSON(e);
    }
  }

  async fetchHotels(codes: string[]): Promise<CmsHotelData[]> {
    this._isBusy = true;
    try {
      const response = await fetch(this._apiUrl + this.hotelsUrl + '?codes=' + codes.join(','), {
        headers: {
          'Accept-Language': i18next.language
        }
      });
      if (response && response.status !== 204) {
        const jsonResponse = await response.json();
        if (
          jsonResponse &&
          Object.entries(jsonResponse) &&
          Object.entries(jsonResponse).length > 0
        ) {
          return jsonResponse;
        }
      }
      this._isBusy = false;
      return [];
    } catch (e) {
      this._isBusy = false;
      throw ApiErrorResponseFromJSON(e);
    }
  }
}

export default CmsHotelService;
